import type { AnalyticEvents } from './analytic-events/analytic-events';
import type { AnalyticProvider, Screen, ValidPropertyType } from './analytics';

declare global {
    interface Window {
        dataLayer?: unknown[];
    }
}

/** GTM container for Next.js apps deployed to wand.com. */
export const WAND_COM_GTM_ID = 'GTM-MRGWZVR3';

export class GoogleAnalytics implements AnalyticProvider {
    #gtmId: string;
    constructor(gtmId: string) {
        this.#gtmId = gtmId;
    }

    public initialize(): void {
        if (typeof window === 'undefined' || !this.#gtmId) {
            return;
        }

        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            'gtm.start': Date.now(),
            event: 'gtm.js',
            dataSource: 'wand_website',
        });

        const script = document.createElement('script');
        script.async = true;
        script.src = `https://metrics.wand.com/gtm.js?id=${this.#gtmId}`;
        document.head.appendChild(script);
    }

    public track<T extends keyof AnalyticEvents>(event: T, params: AnalyticEvents[T]['params']) {
        if (typeof window === 'undefined' || !window.dataLayer) {
            return;
        }

        window.dataLayer.push({
            event: 'client_event',
            clientEventName: event,
            clientEventData: params, //TODO this should be snake-cased for consistency but snake-casing these params would result in a mismatch between "new" and "old" events
            // clientEventData: typeof params === 'object' ? snakeCaseObject(params) : {},
        });
    }

    public screenView(screen: Screen): void {
        this.track('screen_view', {
            screen_name: screen.name,
            screen_class: screen.class,
            ...(screen.params || null),
        });
    }

    public setUserProperty(name: string, value: ValidPropertyType): void {
        if (typeof window === 'undefined' || !window.dataLayer) {
            return;
        }

        window.dataLayer.push({
            event: 'set',
            params: {
                user_properties: {
                    [name]: value,
                },
            },
        });
    }
}
